import React from "react";
import Button from '@mui/material/Button';
import { ValidateLeaseInput } from "./../ValidateLeaseInput";
const btnsArray = [
  { buttonOperation: "Display" },
  { buttonOperation: "Change" },
  { buttonOperation: "Create" },
];

export default function OverviewButtons({
  lease,
  navigate,
  _getLeaseExists,
  _createErrorMessage,
}) {
  const onClick = (buttonOperation, noValidation, navPath) => {
    let navigationUrl;
    if (buttonOperation === "Create") {
      navigationUrl = `/Lease/Create`;
      navigate(navigationUrl);
      return;
    }

    let validationLeaseResult = ValidateLeaseInput(lease, _createErrorMessage);

    if (!validationLeaseResult) {
      return;
    }

    _getLeaseExists({ data: { Id: lease } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("80");
        return;
      }
      const navigationUrl = `/Lease/${lease}/${buttonOperation}`;
      navigate(navigationUrl);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ buttonOperation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }} key={i}>
          <Button
            className="btn btn-primary w-100"
            onClick={() => onClick(buttonOperation, noValidation, navPath)}
          >
            {buttonOperation}
          </Button>
        </div>
      ))}
    </div>
  );
}
